<template>
    <div data-v-81bc5172>
        <div data-v-81bc5172="" class="el-card is-never-shadow" style="font-size: 14px; text-align: left;">
            <div class="el-card__body">
                搜索结果：
                {{searchkey}}
            </div>
        </div>
        <div data-v-81bc5172 class="el-col el-col-24">
            <div data-v-63c6a108 data-v-81bc5172>
                <div data-v-63c6a108 class="el-row" style="z-index: 0;">
                    <div v-for="s in sdata" data-v-63c6a108="" class="el-col el-col-24 el-col-xs-24 el-col-sm-12 el-col-md-8 el-col-lg-8">
                        <a data-v-63c6a108="" :href="'show?id='+s.id" class="">
                            <div data-v-63c6a108="" class="el-card is-hover-shadow" style="margin: 0.1rem !important;">
                                <div class="el-card__body" style="padding: 0px; height: 160px;">
                                    <div data-v-63c6a108="" class="C-InfoCard">
                                        <div data-v-63c6a108="" class="Content">
                                            <div data-v-63c6a108="" class="Title">{{s.title}}</div>
                                            <div data-v-63c6a108="">
                                                <div data-v-63c6a108="" class="State">
                                                    <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108=""
                                                            aria-hidden="true" class="svg-icon"
                                                            style="fill: rgb(153, 153, 153);">
                                                            <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                                                        </svg> <span data-v-63c6a108="">{{s.create_time}}</span></div>
                                                    &nbsp;&nbsp;
                                                    <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108=""
                                                            aria-hidden="true" class="svg-icon"
                                                            style="fill: rgb(153, 153, 153);">
                                                            <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                                                        </svg> <span data-v-63c6a108="">{{s.browse}}</span></div>
                                                </div>
                                                <div data-v-63c6a108="" class="Desc">{{s.process}}</div>
                                            </div>
                                            <div data-v-63c6a108="" class="Location">
                                                <div data-v-63c6a108="" class="Left"><svg data-v-73b7ef61=""
                                                        data-v-63c6a108="" aria-hidden="true" class="svg-icon"
                                                        style="fill: rgb(255, 51, 153);">
                                                        <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                                                    </svg> <span data-v-63c6a108="">{{s.dz}}</span></div>
                                                <div data-v-63c6a108="" class="Tags"> </div>
                                            </div>
                                        </div> <img data-v-63c6a108="" alt="img" :src="s.img" onerror="this.remove()" class="Cover">
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div data-v-63c6a108="">
                    <div data-v-63c6a108="" class="el-card is-never-shadow" style="margin: 0px;">
                        <div class="el-card__body" style="margin: 20px;">
                            <el-pagination
                                background
                                layout="pager"
                                :total="total"
                                :pager-count="5"
                                @current-change="pageclick"
                                :page-size="24"
                                :current-page=currentpage
                                >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'search',
    data() {
        return {

            total:null,
            currentpage:1,

            searchkey:'',
            sdata:[],

        }
    },
    methods:{
        pageclick(pp){

            let q = this.$route.query.q

            let page = this.$route.query.page

            window.location.href = '/search?q='+q+'&page='+pp
        }
    },
    mounted() {
        
        let q = this.$route.query.q

        let page = this.$route.query.page

        this.searchkey = q

        this.currentpage = Number(page)

        if(page){

            this.$http.post('/api/search',{key:q,page:page}).then(res=>{

                this.sdata = res.data.data
                this.total = res.data.count

            })

        }else{

            this.$http.post('/api/search',{key:q,page:1}).then(res=>{

                this.sdata = res.data.data
                this.total = res.data.count

            })

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/search.vue